import { Check, X } from "lucide-react";
import {
  SimpleColumn,
  SimpleSortableTable,
} from "../../../../../components/ui/simple-sortable-table";
import { ProcessedFile } from "../types";

interface ProcessedFilesTableProps {
  files: ProcessedFile[];
}

const columns: SimpleColumn<ProcessedFile>[] = [
  {
    key: "all_ops",
    label: "Franqueados",
    cellClassName: "font-medium",
  },
  {
    key: "current_ops",
    label: "Processado",
    headClassName: "w-32 text-center",
    cellClassName: "text-center",
    sortValue: (file) => file.current_ops !== null,
    render: (file) =>
      file.current_ops !== null ? (
        <Check className="h-5 w-5 text-green-600 inline-block" />
      ) : (
        <X className="h-5 w-5 text-red-600 inline-block" />
      ),
  },
];

export function ProcessedFilesTable({ files }: ProcessedFilesTableProps) {
  return (
    <div className="rounded-md border">
      <SimpleSortableTable
        columns={columns}
        rows={files}
        rowKey={(file, index) => file.id || index}
      />
    </div>
  );
}
